export function isInt(str) {
    return !isNaN(str) && Number.isInteger(parseFloat(str))
}

export function isValidDate(str) {
    const date = new Date(str.replace(/-/g, '/'))
    return !isNaN(date.getTime())
}
